// extracted by mini-css-extract-plugin
export var AuthorAvatarContainer = "bj_dB";
export var AuthorBioContainer = "bj_dy";
export var AuthorContainer = "bj_dx";
export var AuthorGradientBackground = "bj_dz";
export var AuthorInfoContainer = "bj_dC";
export var AuthorInfoDetails = "bj_dD";
export var AuthorInfoName = "bj_dF";
export var AuthorInfoSection = "bj_dG";
export var MuiPopperRoot = "bj_b3";
export var MuiTooltipPopper = "bj_b4";